import * as amplitude from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import { AMPLITUDE_KEY } from '../constants';

let amplitudeInitialized = false;

export const initializeAmplitude = () => {
  if (!amplitudeInitialized && AMPLITUDE_KEY) {
    amplitude.add(engagementPlugin());
    amplitude.init(AMPLITUDE_KEY, {
      autocapture: {
        sessions: true,
        pageViews: false,
        formInteractions: false,
        fileDownloads: false,
        elementInteractions: false,
        pageUrlEnrichment: false,
      },
    });
    optOutTracking(false);
    amplitudeInitialized = true;
  } else if (!AMPLITUDE_KEY) {
    console.log('[ERROR] Incorrect or missing Amplitude key');
  }
};

export const deinitializeAmplitude = () => {
  if (amplitudeInitialized) {
    amplitude.reset();
    amplitudeInitialized = false;
  }
};

export const setUserProperties = userProperties => {
  if (amplitudeInitialized && AMPLITUDE_KEY) {
    const identify = new amplitude.Identify();

    Object.entries(userProperties).forEach(([key, value]) => {
      identify.set(key, value);
    });
    amplitude.identify(identify);
  }
};

export const setUserId = userId => {
  if (amplitudeInitialized && AMPLITUDE_KEY) {
    amplitude.setUserId(userId);
  }
};

export const sendEvent = (eventType, eventProperties) => {
  if (amplitudeInitialized && AMPLITUDE_KEY) {
    amplitude.track(eventType, eventProperties);
  }
};

export const sendEventAsync = async (eventType, eventProperties) => {
  if (amplitudeInitialized && AMPLITUDE_KEY) {
    const result = await amplitude.track(eventType, eventProperties).promise;
    if (result.code !== 200) {
      console.log('[ERROR] Amplitude encountered an error', result.message);
    }
  }
};

export const optOutTracking = optOut => amplitude.setOptOut(optOut);
